import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./WelcomePage.css";

const WelcomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const menData = localStorage.getItem("menToShow");
    if (!menData || JSON.parse(menData).length === 0) {
      navigate("/done");
    }
  }, [navigate]);

  return (
    <div className="welcome-page">
      <div className="welcome-card">
        <img
          src="/logos/bond_logo_white.png"
          alt="Bond Logo"
          className="logo-welcome"
        />
        <h2>View New Matches</h2>
        <p>
          Ladies are complimentary in our network. View premier matches to stay active.
        </p>
        <div className="button-container">
          <button className="next-button" onClick={() => navigate("/matches")}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;